import axios from "axios";

class ApiInstance {
  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_URL + "api/",
      withCredentials: true,
      // "Access-Control-Allow-Origin": "*" はサーバー側が設定するヘッダーのため削除
    });

    // リクエストインターセプター: 送信の直前に毎回最新のトークンを取得して付与
    this.instance.interceptors.request.use(
      (config) => {
        let token = window.localStorage.getItem("token");
        if (token && token !== "undefined") {
          try {
            // ローカルストレージにJSON文字列形式（""付き）で保存されている場合を考慮
            if (token.startsWith('"') && token.endsWith('"')) {
              token = JSON.parse(token);
            }
          } catch (error) {
            // パースエラーの場合はそのまま扱う
          }
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // レスポンスインターセプター: 共通のエラーハンドリングとリダイレクト処理
    this.instance.interceptors.response.use(
      (response) => {
        const result = response.data?.result;
        if (result === 8) {
          window.location.href = "/";
          return Promise.reject(new Error("Result 8: Redirecting to login"));
        }
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          // セッションタイムアウト時にログイン画面へリダイレクション
          localStorage.setItem(
            "errorAlert",
            "このセッションはタイムアウトしました。再度ログインを行ってください"
          );
          window.location.href = "/";
        } else if (error?.response?.data?.message) {
          alert(error.response.data.message);
        } else {
          alert("システムエラーが発生しました。事務局へご連絡ください。");
        }
        return Promise.reject(error);
      }
    );
  }

  // 既存のコードとの互換性維持のためのダミーメソッド
  // インターセプターで毎回最新のトークンを読み込むため、ここで再生成する必要はありません
  async first() {
    return Promise.resolve();
  }

  async get(url, param) {
    try {
      return await this.instance.get(url, param);
    } catch (error) {
      // エラー処理はインターセプターで行われるため、ここではログ出力のみ
      console.error("GET Request Error:", error);
    }
  }

  async post(url, postData) {
    try {
      return await this.instance.post(url, postData);
    } catch (error) {
      // エラー処理はインターセプターで行われるため、ここではログ出力のみ
      console.error("POST Request Error:", error);
    }
  }
}

const BaseApi = new ApiInstance();

export default BaseApi;
